"use strict";

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports.Checkbox = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theme = _interopRequireDefault(require("./theme"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: ", ";\n    width: ", ";\n    background-color: ", ";\n    border: thin solid ", ";\n    border-radius: 0.2rem;\n\n    :after {\n        content: \"\";\n        position: absolute;\n        left: ", ";\n        top: ", ";\n        width: ", ";\n        height: ", ";\n        border: solid white;\n        border-width:  ", ";\n        -webkit-transform: rotate(45deg);\n        -ms-transform: rotate(45deg);\n        transform: rotate(45deg);\n        border-radius: 0.1rem;\n\n\n\n        display:  ", ";\n    }\n\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    opacity: 0;\n    cursor: ", ";\n    height: 0;\n    width: 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    display: block;\n    position: relative;\n    // padding-left: 2.2rem;\n    padding-left: ", ";\n    margin-bottom: 1px;\n    cursor: ", ";\n    font-size: 1rem;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;  \n    // height: 2.2rem;\n    height: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
} //https://www.w3schools.com/howto/tryit.asp?filename=tryhow_css_custom_checkbox


var Container = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.size == "small" ? "1rem" : props.size == "large" ? "2.2rem" : "1.6rem";
}, function (props) {
  return props.disabled ? "default" : "pointer";
}, function (props) {
  return props.size == "small" ? "1rem" : props.size == "large" ? "2.2rem" : "1.6rem";
});

var CheckboxInput = _styledComponents["default"].input(_templateObject2(), function (props) {
  return props.disabled ? "default" : "pointer";
});

var Checkmark = _styledComponents["default"].span(_templateObject3(), function (props) {
  return props.size == "small" ? "1rem" : props.size == "large" ? "2.2rem" : "1.6rem";
}, function (props) {
  return props.size == "small" ? "1rem" : props.size == "large" ? "2.2rem" : "1.6rem";
}, function (props) {
  return props.isChecked ? _theme["default"]["default"].primary : props.disabled ? "#EEE" : "#FFF";
}, function (props) {
  return props.isChecked ? _theme["default"]["default"].primary : props.disabled ? "#EEE" : "#BCBCBC";
}, function (props) {
  return props.size == "small" ? "0rem" : props.size == "large" ? ".7rem" : ".5rem";
}, function (props) {
  return props.size == "small" ? "0rem" : props.size == "large" ? ".27rem" : ".25rem";
}, function (props) {
  return props.size == "small" ? "0rem" : props.size == "large" ? ".6rem" : ".4rem";
}, function (props) {
  return props.size == "small" ? "0rem" : props.size == "large" ? "1.2rem" : ".8rem";
}, function (props) {
  return props.size == "small" ? "0rem" : props.size == "large" ? "0 0.15rem 0.15rem 0" : "0 0.15rem 0.15rem 0";
}, function (props) {
  return props.isChecked ? "bloc" : "none";
});

var Checkbox = function Checkbox(props) {
  return /*#__PURE__*/_react["default"].createElement(Container, _extends({
    onClick: props.onClick
  }, props), /*#__PURE__*/_react["default"].createElement(CheckboxInput, _extends({
    type: "checkbox",
    checked: props.checked,
    onChange: function onChange(e) {
      props.onChange(e);
    }
  }, props)), /*#__PURE__*/_react["default"].createElement(Checkmark, _extends({
    isChecked: props.checked
  }, props)));
};

exports.Checkbox = Checkbox;